import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import range from 'lodash/range';

/*
  Top level progress bar that shows the current step of a process.
  Content varies between desktop and mobile.
*/
export default class TopProgressBar extends React.Component {
  renderSubstep(substep, isCurrent) {
    return (
      <li key={substep} className={isCurrent? "active" : ""}>
        <span className={"fa fa-circle" + (isCurrent? "" : "-o")}></span>
      </li>)
  }

  renderStep(step, isCurrent, isLast, currentSubstep) {
    const stepContent = (
      <span>
        {/* mobile */}
        <div className="show-for-small-only">
          <span className={"fa fa-" + step.icon}></span>
        </div>

        <div className="step-title">{step.title}</div>

        {/* desktop */}
        <div className="hide-for-small-only">
          { (!isCurrent || step.substepCount === 0) && !isLast &&
          <span className="fa fa-long-arrow-right"></span> }

          { isCurrent &&
          <ol className="substeps form-position">
          { range(step.substepCount).map((s) => this.renderSubstep(s, s <= currentSubstep)) }
          </ol> }
        </div>
      </span>
    );

    return (
      <li key={step.title} className={isCurrent? "active":""}>
        { step.link? <Link to={step.link}>{ stepContent }</Link> : stepContent }
      </li>
    )
  }

  render() {
    const { steps, currentStep, currentSubstep } = this.props
    const classes = classNames("top-progress-bar", {
      /* show expanded bar on mobile during the first substep of each step */
      "expanded": currentSubstep == 0
    })
    return (
      <div className={classes}>
        <div className="row">
          <div className="columns medium-16">
            <ul>
              {steps.map((step, i) => {
                return this.renderStep(step, i == currentStep, i == steps.length - 1, currentSubstep)
              })}
            </ul>
          </div>
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./common/components/top_progress_bar.jsx